const ExternalBrandLightValues = Object.freeze({
    apple: {
        base: {
            default: '#000000',
            action: '#1a1a1a',
            active: '#000000',
            activeAction: '#1a1a1a',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    facebook: {
        base: {
            default: '#0766ff',
            action: '#0050d1',
            active: '#0766ff',
            activeAction: '#0050d1',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    google: {
        base: {
            default: '#f2f2f2',
            action: '#c2c2c2',
            active: '#f2f2f2',
            activeAction: '#c2c2c2',
        },
        text: {
            default: '#1f1f1f',
            action: '#1f1f1f',
            active: '#1f1f1f',
            activeAction: '#1f1f1f',
        },
    },
    snapchat: {
        base: {
            default: '#FFFC00',
            action: '#ece801',
            active: '#FFFC00',
            activeAction: '#ece801',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    kakao: {
        base: {
            default: '#FEE500',
            action: '#ebd402',
            active: '#FEE500',
            activeAction: '#ebd402',
        },
        text: {
            default: '#262200',
            action: '#262200',
            active: '#262200',
            activeAction: '#262200',
        },
    },
    line: {
        base: {
            default: '#06C755',
            action: '#1FCD66',
            active: '#048B3C',
            activeAction: '#06C755',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
});
const ExternalBrandDarkValues = Object.freeze({
    apple: {
        base: {
            default: '#ffffff',
            action: '#e6e6e6',
            active: '#ffffff',
            activeAction: '#e6e6e6',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    facebook: {
        base: {
            default: '#0766ff',
            action: '#0050d1',
            active: '#0766ff',
            activeAction: '#0050d1',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    google: {
        base: {
            default: '#f2f2f2',
            action: '#c2c2c2',
            active: '#f2f2f2',
            activeAction: '#c2c2c2',
        },
        text: {
            default: '#1f1f1f',
            action: '#1f1f1f',
            active: '#1f1f1f',
            activeAction: '#1f1f1f',
        },
    },
    snapchat: {
        base: {
            default: '#FFFC00',
            action: '#ece801',
            active: '#FFFC00',
            activeAction: '#ece801',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    kakao: {
        base: {
            default: '#FEE500',
            action: '#ebd402',
            active: '#FEE500',
            activeAction: '#ebd402',
        },
        text: {
            default: '#262200',
            action: '#262200',
            active: '#262200',
            activeAction: '#262200',
        },
    },
    line: {
        base: {
            default: '#06C755',
            action: '#1FCD66',
            active: '#048B3C',
            activeAction: '#06C755',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
});

export { ExternalBrandDarkValues, ExternalBrandLightValues };
